import _defineProperty from "/builds/1-Ndk5Hm/0/webservices/sites/dental-dna-cigna-com/node_modules/@babel/runtime/helpers/esm/defineProperty";
import $ from 'jquery';
import { loadScript } from './util/loader';
import renderTemplate from './util/template';
import limelightHtml5Template from './views/limelight-html5.tpl.html';

var makePlayerID = function makePlayerID() {
  var num = Math.floor(Math.random() * 900000) + 100000;
  return "limelight_player_".concat(num);
};

var buildPlayer = function buildPlayer(video) {
  var _video$dataset = video.dataset,
      _video$dataset$player = _video$dataset.playerId,
      playerId = _video$dataset$player === void 0 ? makePlayerID() : _video$dataset$player,
      _video$dataset$conten = _video$dataset.contentType,
      contentType = _video$dataset$conten === void 0 ? 'channel' : _video$dataset$conten;

  if (!video.dataset.playerId) {
    video.dataset.playerId = playerId;
  }

  if (!video.dataset.contentType) {
    video.dataset.contentType = contentType;
  }

  return renderTemplate(limelightHtml5Template, {
    playerId: playerId
  });
};

export default (function () {
  // Embeds should NOT contain <script> tags, that is handled here now
  var limelightComponents = $('.limelight-component');
  loadScript('//video.limelight.com/player/limelightjs-player.js').then(function () {
    limelightComponents.each(function (index, video) {
      var _LimelightPlayerUtil$;

      var contentIdKey = video.dataset.contentType === 'media' ? 'mediaId' : 'channelId';
      var html = buildPlayer(video);
      $(video).append(html); // eslint-disable-next-line no-undef

      LimelightPlayerUtil.embed((_LimelightPlayerUtil$ = {
        playerId: video.dataset.playerId
      }, _defineProperty(_LimelightPlayerUtil$, contentIdKey, video.dataset.contentId), _defineProperty(_LimelightPlayerUtil$, "playerForm", video.dataset.playerFormId), _LimelightPlayerUtil$));
    });
  });
});